export default "__VITE_ASSET__DhcLHEzS__"